/**
 * TRUTEX AUTOMOTIVE - SHOPIFY 2.0 THEME JAVASCRIPT (assets/theme.js)
 * Consolidated Master Script: AJAX Cart Engine, Preloader Controller,
 * Lightbox Gallery, Search Modal & Interactivity.
 * 
 * Bundles all frontend scripts into a single non-blocking file to reduce HTTP requests.
 */

(function() {
  'use strict';

  // =========================================================================
  // 1. PRELOADER CONTROLLER (Desaparecimento a 1.0s pós DOMContentLoaded)
  // =========================================================================
  let preloaderHidden = false;
  let preloaderSafetyTimer = null;

  window.hideTrutexPreloader = function() {
    clearTimeout(preloaderSafetyTimer);
    if (window.dismissPreloader) {
      window.dismissPreloader();
    }
    const preloader = document.getElementById('trutex-preloader');
    if (preloader && !preloaderHidden) {
      preloader.style.opacity = '0';
      preloader.style.pointerEvents = 'none';
      if (document.body) {
        document.body.classList.remove('preloader-active');
        document.body.classList.remove('active');
      }
      setTimeout(function() {
        preloader.classList.add('fade-out');
        preloader.classList.remove('active');
        preloader.style.display = 'none';
      }, 300);
    }
    preloaderHidden = true;
  };

  window.showTrutexPreloader = function() {
    const preloader = document.getElementById('trutex-preloader');
    if (preloader) {
      preloaderHidden = false;
      if (document.body) document.body.classList.add('preloader-active');
      preloader.style.display = 'flex';
      delete preloader.dataset.dismissed;
      void preloader.offsetWidth;
      preloader.style.opacity = '1';
      preloader.style.pointerEvents = 'all';
      preloader.classList.remove('fade-out');
      preloader.classList.add('active');

      // Failsafe estrito: máximo 0.5 segundos (500ms) para libertar o utilizador
      clearTimeout(preloaderSafetyTimer);
      preloaderSafetyTimer = setTimeout(window.hideTrutexPreloader, 500);
    }
  };

  // Desativação forçada exatamente 0.5s (500ms) após DOMContentLoaded
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    setTimeout(window.hideTrutexPreloader, 500);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(window.hideTrutexPreloader, 500);
    }, { once: true });
  }
  window.addEventListener('load', function() {
    setTimeout(window.hideTrutexPreloader, 500);
  }, { once: true });
  setTimeout(window.hideTrutexPreloader, 500);

  // Interceptar apenas navegações completas entre páginas que NÃO sejam AJAX / Filtros
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;

    if (
      link.target === '_blank' ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('https://wa.me') ||
      href.startsWith('javascript:') ||
      e.ctrlKey || e.metaKey || e.shiftKey
    ) {
      return;
    }

    // NUNCA acionar preloader em filtros de marca, categoria, paginação, sort ou AJAX
    if (
      link.classList.contains('brand-pill-sub') ||
      link.classList.contains('filter-pill') ||
      link.classList.contains('page-btn') ||
      link.closest('.trutex-pagination') ||
      link.closest('.pills-scroll-row') ||
      link.closest('.category-filter-bar') ||
      link.closest('.quick-brand-filter-bar') ||
      link.closest('.collection-sort-container') ||
      link.hasAttribute('data-category') ||
      link.hasAttribute('data-brand') ||
      link.hasAttribute('data-ajax-bound') ||
      link.hasAttribute('data-no-preloader')
    ) {
      return;
    }

    const isSameHost = link.hostname === window.location.hostname || !link.hostname;
    if (isSameHost) {
      const targetUrl = link.href;
      if (targetUrl && targetUrl !== window.location.href) {
        window.showTrutexPreloader();
      }
    }
  });

  window.addEventListener('popstate', function() {
    window.hideTrutexPreloader();
  });

  window.addEventListener('pageshow', function() {
    window.hideTrutexPreloader();
  });

  // =========================================================================
  // 2. SHOPIFY AJAX CART ENGINE & LOCALIZAÇÃO DINÂMICA
  // =========================================================================
  function getActiveCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.TrutexLocalization && window.TrutexLocalization.currency) ||
      localStorage.getItem('trutex_user_currency') ||
      'EUR';
  }

  function getActiveLocale() {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('/en') || path.startsWith('/en')) return 'en';
    if (path.includes('/de') || path.startsWith('/de')) return 'de';
    if (path.includes('/fr') || path.startsWith('/fr')) return 'fr';
    if (path.includes('/it') || path.startsWith('/it')) return 'it';
    if (path.includes('/es') || path.startsWith('/es')) return 'es';
    return (window.Shopify && window.Shopify.locale) ||
      (window.TrutexLocalization && window.TrutexLocalization.locale) ||
      localStorage.getItem('trutex_user_locale') ||
      'pt';
  }

  function formatMoneyDynamic(cents, currencyCode) {
    const currency = (currencyCode || getActiveCurrency()).toUpperCase();
    const locale = getActiveLocale();
    const isInvalid = isNaN(cents) || cents === null || cents === undefined;
    const numCents = isInvalid ? 0 : Number(cents);
    const amountVal = numCents / 100;

    // Formatação rigorosa de acordo com a localização e moeda ativa (€, $, £, CHF)
    try {
      const localeTagMap = {
        'pt': 'pt-PT',
        'en': 'en-GB',
        'de': 'de-DE',
        'fr': 'fr-FR',
        'es': 'es-ES',
        'it': 'it-IT'
      };
      const langPrefix = locale.split(/[-_]/)[0].toLowerCase();
      let bcp47 = localeTagMap[langPrefix] || (locale.includes('-') ? locale : 'pt-PT');
      if (currency === 'USD') {
        bcp47 = langPrefix === 'en' ? 'en-US' : (localeTagMap[langPrefix] || 'pt-PT');
      } else if (currency === 'GBP') {
        bcp47 = langPrefix === 'en' ? 'en-GB' : (localeTagMap[langPrefix] || 'pt-PT');
      }

      return new Intl.NumberFormat(bcp47, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amountVal);
    } catch (e) {
      const amount = amountVal.toFixed(2);
      if (currency === 'USD') {
        return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      if (currency === 'GBP') {
        return '£' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      if (currency === 'CHF') {
        return 'CHF ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      }

      if (currency === 'EUR') {
        if (locale.startsWith('en')) {
          return '€' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        const parts = amount.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return parts.join(',') + ' €';
      }

      const parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',') + ' ' + currency;
    }
  }

  function formatMoneyPT(cents, currencyCode) {
    return formatMoneyDynamic(cents, currencyCode);
  }
  window.formatMoneyPT = formatMoneyPT;
  window.formatMoneyDynamic = formatMoneyDynamic;

  // Sincronizador de Tradução e Notificação de Impostos (IVA incluído / Tax included)
  function syncThemeLocalization() {
    const locale = getActiveLocale();
    const taxNotices = document.querySelectorAll('#product-tax-notice, .product-tax-notice');
    let taxLabel = '(IVA incluído)';

    if (locale.startsWith('en')) {
      taxLabel = '(Tax included)';
    } else if (locale.startsWith('de')) {
      taxLabel = '(inkl. MwSt.)';
    } else if (locale.startsWith('fr')) {
      taxLabel = '(TVA incluse)';
    } else if (locale.startsWith('it')) {
      taxLabel = '(IVA inclusa)';
    } else if (locale.startsWith('es')) {
      taxLabel = '(IVA incluido)';
    }

    taxNotices.forEach(function(el) {
      el.textContent = taxLabel;
    });

    // Garantir que badges de personalização exibem 'PERSONALIZADO'
    const customPills = document.querySelectorAll('.pill-personalizado, .pill-custom-gradient');
    customPills.forEach(function(pill) {
      if (pill.textContent.trim().toUpperCase().includes('EDIÇÃO')) {
        pill.textContent = 'PERSONALIZADO';
      }
    });

    // Sanitização de segurança de traduções em falta
    if (typeof window.trutexSanitizeTranslation === 'function' && document.body) {
      try {
        const walker = document.createTreeWalker(
          document.body,
          NodeFilter.SHOW_TEXT,
          {
            acceptNode: function(node) {
              return (node.nodeValue && node.nodeValue.toLowerCase().indexOf('translation missing') !== -1)
                ? NodeFilter.FILTER_ACCEPT
                : NodeFilter.FILTER_SKIP;
            }
          },
          false
        );
        let node;
        while ((node = walker.nextNode())) {
          node.nodeValue = window.trutexSanitizeTranslation(node.nodeValue);
        }
      } catch (e) {}
    }
  }
  window.syncThemeLocalization = syncThemeLocalization;

  function updateCartCounters(count) {
    const badges = document.querySelectorAll('.cart-badge-count, [data-cart-count]');
    badges.forEach(badge => {
      badge.textContent = count;
      if (count > 0) {
        badge.style.display = 'flex';
        badge.removeAttribute('hidden');
      } else {
        badge.style.display = 'none';
      }
    });
  }
  window.updateCartBadges = updateCartCounters;

  window.openCartDrawer = function() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');
    if (drawer) drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = function() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');
    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  window.renderCartDrawer = function(cart) {
    const container = document.getElementById('cart-drawer-items');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const countHeader = document.getElementById('cart-drawer-item-count');
    const footerEl = document.querySelector('.cart-drawer-footer');

    if (countHeader) {
      countHeader.textContent = cart.item_count === 1 ? '1 artigo' : cart.item_count + ' artigos';
    }

    updateCartCounters(cart.item_count);

    if (subtotalEl) {
      subtotalEl.textContent = formatMoneyPT(cart.total_price);
    }

    if (!container) return;

    if (!cart || cart.item_count === 0) {
      container.innerHTML = `
        <div style="text-align: center; padding: 60px 20px; color: #a1a1aa;">
          <div style="width: 64px; height: 64px; margin: 0 auto 16px; border-radius: 50%; background: #18181b; border: 1px solid #27272a; display: flex; align-items: center; justify-content: center; color: #71717a;">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="8" cy="21" r="1"></circle>
              <circle cx="19" cy="21" r="1"></circle>
              <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
            </svg>
          </div>
          <p style="font-size: 1.05rem; font-weight: 700; color: #ffffff; margin-bottom: 8px;">O teu carrinho está vazio.</p>
          <p style="font-size: 0.85rem; color: #71717a; margin-bottom: 24px;">Explora os nossos volantes desportivos e componentes exclusivos.</p>
          <a href="/collections/all" class="btn btn-secondary" style="display: inline-block; padding: 12px 24px; font-size: 0.85rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; border-radius: 8px;">
            Ver Catálogo
          </a>
        </div>
      `;
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';

    let html = '<div style="display: flex; flex-direction: column;">';
    cart.items.forEach((item, index) => {
      const isLast = index === cart.items.length - 1;
      const borderStyle = isLast ? '' : 'border-bottom: 1px solid rgba(255, 255, 255, 0.08);';
      const variantDisplay = item.variant_title && !item.variant_title.includes('Default')
        ? `<div style="font-size: 0.78rem; color: #a1a1aa; margin-top: 2px;">${item.variant_title}</div>`
        : '';

      let propertiesDisplay = '';
      if (item.properties && typeof item.properties === 'object') {
        const propEntries = Object.entries(item.properties).filter(([k, v]) => v && !k.startsWith('_'));
        if (propEntries.length > 0) {
          propertiesDisplay = `
            <div class="cart-item-properties" style="margin-top: 6px; padding: 6px 8px; background: rgba(255, 255, 255, 0.04); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 6px; font-size: 0.72rem; line-height: 1.4;">
              ${propEntries.map(([k, v]) => `
                <div style="display: flex; gap: 4px; justify-content: space-between;">
                  <span style="color: #a1a1aa;">${k}:</span>
                  <span style="color: #ef4444; font-weight: 700;">${v}</span>
                </div>
              `).join('')}
            </div>
          `;
        }
      }

      const itemImg = item.featured_image && item.featured_image.url
        ? item.featured_image.url
        : (item.image || '');

      html += `
        <div class="cart-drawer-item" data-line-key="${item.key}" style="display: flex; gap: 14px; padding: 18px 0; ${borderStyle} background: #000000;">
          <div style="width: 72px; height: 72px; border-radius: 8px; overflow: hidden; background: #111116; border: 1px solid rgba(255, 255, 255, 0.1); flex-shrink: 0;">
            ${itemImg ? `<img src="${itemImg}" alt="${item.title}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;" />` : ''}
          </div>

          <div style="flex-grow: 1; display: flex; flex-direction: column; justify-content: space-between;">
            <div>
              <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
                <h4 style="margin: 0; font-size: 0.9rem; font-weight: 800; color: #ffffff; line-height: 1.3;">
                  <a href="${item.url}" style="color: #ffffff; text-decoration: none;">${item.product_title}</a>
                </h4>
                <button 
                  type="button" 
                  class="cart-remove-btn"
                  data-cart-remove="${item.key}"
                  title="Remover produto"
                  style="background: none; border: none; padding: 4px; color: #71717a; cursor: pointer; transition: color 0.2s;"
                  onmouseover="this.style.color='#ef4444'" 
                  onmouseout="this.style.color='#71717a'"
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
              ${variantDisplay}
              ${propertiesDisplay}
            </div>

            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 12px;">
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 0.75rem; color: #a1a1aa; font-weight: 600; text-transform: uppercase;">Quantidade:</span>
                <div style="display: inline-flex; align-items: center; background: #111116; border: 1px solid rgba(255, 255, 255, 0.15); border-radius: 6px; padding: 2px;">
                  <button 
                    type="button" 
                    class="qty-btn"
                    data-cart-change="${item.key}"
                    data-qty="${item.quantity - 1}"
                    aria-label="Diminuir quantidade"
                    style="width: 26px; height: 26px; background: transparent; border: none; color: #ffffff; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 800;"
                    onmouseover="this.style.color='#e31b23'"
                    onmouseout="this.style.color='#ffffff'"
                  >&minus;</button>
                  <span style="min-width: 24px; text-align: center; font-size: 0.8rem; font-weight: 800; color: #ffffff;">${item.quantity}</span>
                  <button 
                    type="button" 
                    class="qty-btn"
                    data-cart-change="${item.key}"
                    data-qty="${item.quantity + 1}"
                    aria-label="Aumentar quantidade"
                    style="width: 26px; height: 26px; background: transparent; border: none; color: #ffffff; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 800;"
                    onmouseover="this.style.color='#e31b23'"
                    onmouseout="this.style.color='#ffffff'"
                  >+</button>
                </div>
              </div>

              <span style="font-size: 1rem; font-weight: 900; color: #ffffff; font-family: var(--font-display, sans-serif); letter-spacing: -0.01em;">
                ${formatMoneyPT(item.final_line_price)}
              </span>
            </div>
          </div>
        </div>
      `;
    });

    html += '</div>';
    container.innerHTML = html;
  };

  window.renderCartDrawerItems = window.renderCartDrawer;

  window.fetchShopifyCart = async function() {
    try {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (response.ok) {
        const cart = await response.json();
        window.renderCartDrawer(cart);
        return cart;
      }
    } catch (err) {
      console.warn('[TRUTEX AJAX Cart] Fetch cart warning:', err);
    }
    return null;
  };
  window.fetchCart = window.fetchShopifyCart;

  window.updateCartItemQuantity = async function(key, quantity) {
    const container = document.getElementById('cart-drawer-items');
    if (container) {
      container.style.opacity = '0.6';
      container.style.pointerEvents = 'none';
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: Math.max(0, parseInt(quantity, 10))
        })
      });

      if (response.ok) {
        const cart = await response.json();
        window.renderCartDrawer(cart);
      } else {
        const error = await response.json();
        console.error('[TRUTEX Cart Change Error]:', error);
      }
    } catch (err) {
      console.error('[TRUTEX Cart Network Error]:', err);
    } finally {
      if (container) {
        container.style.opacity = '1';
        container.style.pointerEvents = 'auto';
      }
    }
  };

  window.addDynamicProductToCart = async function(variantId, quantity = 1, formElement = null, customProperties = null) {
    if (!variantId) {
      console.error('[TRUTEX AJAX Cart] Erro: variantId não especificado.');
      return;
    }

    const cleanVariantId = String(variantId).trim();
    const cleanQuantity = Math.max(1, parseInt(quantity, 10) || 1);

    // Extrair propriedades personalizadas de linha de encomenda
    const properties = { ...(customProperties || {}) };
    if (formElement) {
      const propInputs = formElement.querySelectorAll('[name^="properties["]');
      propInputs.forEach(input => {
        const match = input.name.match(/^properties\[(.*?)\]$/);
        if (match && match[1] && input.value !== undefined && input.value !== '') {
          properties[match[1]] = input.value;
        }
      });
    }

    let submitBtn = null;
    let originalText = '';

    if (formElement) {
      submitBtn = formElement.querySelector('button[type="submit"], [name="add"], .btn-primary');
      if (submitBtn) {
        originalText = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML = `
          <svg style="animation: spin 0.8s linear infinite; width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 6px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" stroke-opacity="0.25"></circle>
            <path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path>
          </svg>
          A ADICIONAR...
        `;
      }
    }

    const container = document.getElementById('cart-drawer-items');
    if (container) {
      container.style.opacity = '0.5';
      container.style.pointerEvents = 'none';
    }

    try {
      const payloadBody = {
        id: cleanVariantId,
        quantity: cleanQuantity
      };
      if (Object.keys(properties).length > 0) {
        payloadBody.properties = properties;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payloadBody)
      });

      if (response.ok) {
        const addedItem = await response.json();
        await window.fetchShopifyCart();
        window.openCartDrawer();
        return addedItem;
      } else {
        const errorData = await response.json();
        console.error('[TRUTEX Cart Add Error]:', errorData);
        alert(errorData.description || 'Não foi possível adicionar o produto ao carrinho.');
      }
    } catch (err) {
      console.warn('[TRUTEX Cart Add Dev/Local]:', err);
      window.openCartDrawer();
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
      if (container) {
        container.style.opacity = '1';
        container.style.pointerEvents = 'auto';
      }
    }
  };
  window.addItemToCart = window.addDynamicProductToCart;

  // =========================================================================
  // 3. SEARCH MODAL CONTROLLER
  // =========================================================================
  window.openSearchModal = function() {
    const modal = document.getElementById('search-modal');
    if (modal) {
      modal.style.display = 'flex';
      const input = modal.querySelector('input[type="search"]');
      if (input) setTimeout(() => input.focus(), 100);
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeSearchModal = function() {
    const modal = document.getElementById('search-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  // =========================================================================
  // 4. EVENT LISTENERS & INITIALIZATION
  // =========================================================================
  document.addEventListener('DOMContentLoaded', function() {
    // Triggers do Carrinho
    document.querySelectorAll('[data-cart-trigger], .cart-trigger-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.openCartDrawer();
      });
    });

    document.querySelectorAll('[data-cart-close]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.closeCartDrawer();
      });
    });

    // Triggers da Pesquisa
    document.querySelectorAll('[data-search-trigger]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.openSearchModal();
      });
    });

    document.querySelectorAll('[data-search-close]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.closeSearchModal();
      });
    });

    // Fechar modais ao premir Esc
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        window.closeCartDrawer();
        window.closeSearchModal();
      }
    });

    // Delegação de eventos no carrinho (Quantidade & Remoção)
    document.addEventListener('click', function(e) {
      const changeBtn = e.target.closest('[data-cart-change]');
      if (changeBtn) {
        e.preventDefault();
        const key = changeBtn.getAttribute('data-cart-change');
        const qty = parseInt(changeBtn.getAttribute('data-qty'), 10);
        if (key) {
          window.updateCartItemQuantity(key, qty);
        }
        return;
      }

      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.getAttribute('data-cart-remove');
        if (key) {
          window.updateCartItemQuantity(key, 0);
        }
        return;
      }
    });

    // Submissão AJAX dinâmica de produtos
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      const isProductForm = 
        form.id === 'trutex-product-form' || 
        form.classList.contains('product-form') || 
        form.getAttribute('action')?.includes('/cart/add');

      if (isProductForm) {
        e.preventDefault();
        e.stopPropagation();

        let targetVariantId = null;
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.value) {
          targetVariantId = idInput.value.trim();
        }

        if (!targetVariantId) {
          const selectElement = form.querySelector('select[name="id"]');
          if (selectElement && selectElement.value) {
            targetVariantId = selectElement.value.trim();
          }
        }

        const qtyInput = form.querySelector('input[name="quantity"]');
        const quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;

        if (targetVariantId) {
          window.addDynamicProductToCart(targetVariantId, quantity, form);
        } else {
          form.submit();
        }
      }
    });

    // Carregamento inicial do carrinho
    window.fetchShopifyCart();

    // =======================================================================
    // 5. FULLSCREEN LIGHTBOX CONTROLLER
    // =======================================================================
    const lightboxModal = document.getElementById('trutex-theme-lightbox') || document.getElementById('trutex-lightbox-modal');
    if (lightboxModal) {
      let activeItems = [];
      let currentIndex = 0;

      const imgEl = document.getElementById('lightbox-active-img');
      const counterEl = document.getElementById('lightbox-counter');
      const titleEl = document.getElementById('lightbox-title');
      const subtitleEl = document.getElementById('lightbox-subtitle');
      const prevBtn = document.getElementById('lightbox-prev');
      const nextBtn = document.getElementById('lightbox-next');

      function updateLightboxView() {
        if (!activeItems.length) return;
        const item = activeItems[currentIndex];
        if (!item) return;

        if (imgEl) {
          imgEl.src = item.src;
          imgEl.alt = item.title || 'Imagem ampliada TRUTEX';
        }
        if (counterEl) {
          counterEl.textContent = (currentIndex + 1) + ' / ' + activeItems.length;
        }
        if (titleEl) {
          titleEl.textContent = item.title || '';
          titleEl.style.display = item.title ? 'block' : 'none';
        }
        if (subtitleEl) {
          subtitleEl.textContent = item.subtitle || '';
          subtitleEl.style.display = item.subtitle ? 'block' : 'none';
        }
        if (prevBtn) {
          prevBtn.style.display = activeItems.length > 1 ? 'flex' : 'none';
        }
        if (nextBtn) {
          nextBtn.style.display = activeItems.length > 1 ? 'flex' : 'none';
        }
      }

      window.openThemeLightbox = function(items, startIndex = 0) {
        if (!items || !items.length) return;
        activeItems = items;
        currentIndex = Math.max(0, Math.min(startIndex, items.length - 1));
        updateLightboxView();
        lightboxModal.style.display = 'flex';
        void lightboxModal.offsetWidth; // Force reflow
        lightboxModal.classList.add('is-open');
        lightboxModal.classList.add('active');
        lightboxModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      window.closeThemeLightbox = function() {
        lightboxModal.classList.remove('is-open');
        lightboxModal.classList.remove('active');
        lightboxModal.setAttribute('aria-hidden', 'true');
        lightboxModal.style.display = 'none';
        document.body.style.overflow = '';
        if (typeof window.trutexSelectPhotoByIndex === 'function' && typeof currentIndex === 'number') {
          window.trutexSelectPhotoByIndex(currentIndex);
        }
      };

      window.lightboxPrev = function() {
        if (activeItems.length <= 1) return;
        currentIndex = (currentIndex - 1 + activeItems.length) % activeItems.length;
        updateLightboxView();
        if (typeof window.trutexSelectPhotoByIndex === 'function') {
          window.trutexSelectPhotoByIndex(currentIndex);
        }
      };

      window.lightboxNext = function() {
        if (activeItems.length <= 1) return;
        currentIndex = (currentIndex + 1) % activeItems.length;
        updateLightboxView();
        if (typeof window.trutexSelectPhotoByIndex === 'function') {
          window.trutexSelectPhotoByIndex(currentIndex);
        }
      };

      // 1. EventListeners robustos ao botão de fechar (X) e ao fundo preto (Backdrop)
      const closeTargets = lightboxModal.querySelectorAll('#lightbox-close, #lightbox-close-btn, [data-lightbox-close], .lightbox-btn-close, .lightbox-backdrop');
      closeTargets.forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          window.closeThemeLightbox();
        });
      });

      // 2. EventListeners nas setas de navegação
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          window.lightboxPrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          window.lightboxNext();
        });
      }

      // 3. Atalhos de Teclado (ESC para fechar, Setas para navegar)
      document.addEventListener('keydown', function(e) {
        const isOpen = lightboxModal.classList.contains('is-open') || 
                       lightboxModal.classList.contains('active') || 
                       lightboxModal.style.display === 'flex' ||
                       lightboxModal.getAttribute('aria-hidden') === 'false';
        if (!isOpen) return;

        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          e.stopPropagation();
          window.closeThemeLightbox();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          e.stopPropagation();
          window.lightboxPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          e.stopPropagation();
          window.lightboxNext();
        }
      });

      // 4. Suporte a Swipe no Mobile
      let touchStartX = 0;
      let touchEndX = 0;
      lightboxModal.addEventListener('touchstart', function(e) {
        if (e.changedTouches && e.changedTouches.length) {
          touchStartX = e.changedTouches[0].screenX;
        }
      }, { passive: true });

      lightboxModal.addEventListener('touchend', function(e) {
        if (e.changedTouches && e.changedTouches.length) {
          touchEndX = e.changedTouches[0].screenX;
          const diff = touchEndX - touchStartX;
          if (Math.abs(diff) > 40) {
            if (diff < 0) {
              window.lightboxNext();
            } else {
              window.lightboxPrev();
            }
          }
        }
      }, { passive: true });

      function bindLightboxTriggers() {
        const triggers = document.querySelectorAll('.lightbox-trigger, .customization-steps-section img, .product-media-gallery img');
        triggers.forEach(trigger => {
          if (trigger.dataset.lightboxBound) return;
          trigger.dataset.lightboxBound = 'true';
          trigger.style.cursor = 'zoom-in';

          trigger.addEventListener('click', function(e) {
            e.preventDefault();
            const gallery = Array.from(triggers).map(t => ({
              src: t.getAttribute('data-lightbox-src') || t.getAttribute('src'),
              title: t.getAttribute('data-lightbox-title') || t.getAttribute('alt') || '',
              subtitle: t.getAttribute('data-lightbox-subtitle') || ''
            }));
            const foundIndex = gallery.findIndex(g => g.src === (trigger.getAttribute('data-lightbox-src') || trigger.getAttribute('src')));
            window.openThemeLightbox(gallery, foundIndex >= 0 ? foundIndex : 0);
          });
        });
      }

      bindLightboxTriggers();
      window.bindLightboxTriggers = bindLightboxTriggers;
    }

    // =========================================================================
    // 6. PROTEÇÃO DE IMAGENS TRUTEX (ANTI-CÓPIA, ANTI-DRAG & OVERLAY DISCRETO)
    // =========================================================================
    function initTrutexImageProtection() {
      const isProtectedTarget = function(el) {
        if (!el || !(el instanceof Element)) return false;
        return el.matches(
          '.trutex-protected-img, .trutex-main-img, .trutex-card-img, .lightbox-image-container img, ' +
          '.trutex-watermark-overlay, .trutex-watermark-img, .trutex-featured-image-container img, .trutex-card-media img'
        ) || Boolean(el.closest('.trutex-featured-image-container, .trutex-card-media, .lightbox-image-container'));
      };

      // 1. Desativar menu de contexto / botão direito sobre as imagens dos produtos
      document.addEventListener('contextmenu', function(e) {
        if (isProtectedTarget(e.target)) {
          e.preventDefault();
          return false;
        }
      }, { capture: true });

      // 2. Impedir arrastamento nativo (drag & drop) das imagens para o ambiente de trabalho ou pasta
      document.addEventListener('dragstart', function(e) {
        if (isProtectedTarget(e.target)) {
          e.preventDefault();
          return false;
        }
      }, { capture: true });

      // 3. Impedir atalhos de gravação direta (Ctrl+S / Cmd+S) quando o foco estiver na imagem
      document.addEventListener('keydown', function(e) {
        if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) {
          const active = document.activeElement;
          if (active && isProtectedTarget(active)) {
            e.preventDefault();
          }
        }
      });

      // 4. Inibir menu de toque longo (Callout: Save to Photos, Share, Copy Subject) no iOS Safari
      document.addEventListener('touchstart', function(e) {
        if (isProtectedTarget(e.target)) {
          if (e.target.style) {
            e.target.style.webkitTouchCallout = 'none';
            e.target.style.webkitUserSelect = 'none';
          }
        }
      }, { passive: true });
    }

    initTrutexImageProtection();

    // Inicialização da sincronização de localização e textos de impostos
    if (typeof syncThemeLocalization === 'function') {
      syncThemeLocalization();
    }
  });
})();
